import { useLocation } from 'react-router-dom';
import { useGetScriveConfirmationTextsQuery } from '../applicationApi';
import { ApplicationTypeEnum } from '../../../types/ApplicationV3/application';
import { toFrontendApplicationType } from '../applicationTypeMapper';
import confirmationStyles from './ConfirmationPage.module.scss';
import applicationStyles from '../Application.module.scss';
import sanitize from 'sanitize-html';
import EnvelopeStripesIcon from '../../../images/envelope_w_stripes.svg?react';
import tslLogoBlack from '../../../images/tsl-logo-black.svg';
import FormBlock from 'components/formComponents/Layout/FormBlock';

const ScriveConfirmationPage = () => {
  const styles = { ...confirmationStyles, ...applicationStyles };
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const applicationTypeParam = queryParams.get('applicationType');
  const normalizedApplicationType =
    toFrontendApplicationType(applicationTypeParam) ??
    ApplicationTypeEnum.OngoingEmployment;
  const { data: texts } = useGetScriveConfirmationTextsQuery(
    normalizedApplicationType
  );

  const branding = (
    <div className={styles.branding}>
      <a href="https://www.tsl.se/" target="_blank" rel="noopener noreferrer">
        <img className={styles.logo} src={tslLogoBlack} alt="TSL logga" />
      </a>
    </div>
  );

  return (
    <div className={styles.page}>
      {branding}
      <div className={`${styles.container} ${styles.containerCentered}`}>
        <FormBlock title={texts?.headline ?? 'Tack för din ansökan!'}>
          <div className={styles.wrapper}>
            <div className={styles.header}>
              <EnvelopeStripesIcon />
            </div>
            <div className={styles.subSection}>
              <p className={styles.subheader}>
                {texts?.whatHappensNowSubheader ?? 'Vad händer nu?'}
              </p>
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitize(texts?.whatHappensNowPreamble ?? ''),
                }}
              />
            </div>
          </div>
        </FormBlock>
      </div>
    </div>
  );
};

export default ScriveConfirmationPage;
